import React, { PropsWithChildren } from 'react';

type AkAnchorProps = {
    href?: string;
} & PropsWithChildren<{}>;

export default function AkAnchor({ href, children }: AkAnchorProps) {
    return <a href={href?.replace(/^(javascript:)/, '')}>{children}</a>;
}
